import { useCallback } from "react";
import ChatMpProvider from "@/core/data-provider/data-mp/chat/chat-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { ChatSetSettingsClientResponse } from "@/core/rpc-mp-provider/messages/chat-set-settings";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setChatOpen } from "@/domains/chat/slice";
import { setAppliedSettings, setMemoizedSettings } from "@/domains/settings/chat/slice";

export default function useChatSettings() {
  const dispatch = useAppDispatch();

  const getChatSettings = useCallback(async () => {
    const response = await ChatMpProvider.setSettings({});
    if (response instanceof RpcMpProviderSuccessResponse) {
      dispatch(setChatOpen(response.data.isOpenChatByDefault));
      dispatch(setAppliedSettings(response.data));
    } else {
      // TODO: уводемить об ошибке
      console.log("initiate settings:", response);
    }
  }, [dispatch]);

  const updateChatSettings = useCallback(
    async (data: ChatSetSettingsClientResponse) => {
      const response = await ChatMpProvider.setSettings(data);
      if (response instanceof RpcMpProviderSuccessResponse) {
        dispatch(setChatOpen(response.data.isOpenChatByDefault));
        dispatch(setAppliedSettings(response.data));
        dispatch(setMemoizedSettings(response.data));
      } else {
        // TODO: уводемить об ошибке
        console.log("update chat settings:", response);
      }
    },
    [dispatch],
  );

  return {
    getChatSettings,
    updateChatSettings,
  };
}
